import { useEffect, useRef } from "react";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";

/**
 * When a member is logged in, link their identity to the Charla chat visitor so support
 * agents see who they're talking to. The Charla widget (loaded in index.html) assigns a
 * VisitorId fingerprint; we read it via the element's getVisitorId() once available and
 * post it to the backend, which pushes name/email/plan/tags to Charla.
 * Renders nothing.
 */
export function CharlaIdentifier() {
  const { user } = useAuth();
  const sentForRef = useRef(null);

  useEffect(() => {
    if (!user) {
      sentForRef.current = null;
      return;
    }
    if (sentForRef.current === user.user_id) return;

    let tries = 0;
    const timer = setInterval(async () => {
      tries += 1;
      const el = document.querySelector("charla-widget");
      const vid = el && typeof el.getVisitorId === "function" ? el.getVisitorId() : null;
      if (vid) {
        clearInterval(timer);
        sentForRef.current = user.user_id;
        try {
          await api.post("/integrations/charla/identify", { visitor_id: vid });
        } catch {
          /* non-blocking — identification is best-effort */
        }
      } else if (tries >= 30) {
        clearInterval(timer); // give up after ~30s (widget blocked or no session yet)
      }
    }, 1000);

    return () => clearInterval(timer);
  }, [user]);

  return null;
}
